import { useState, useEffect } from "react";
import { useLanguage } from "@/app/utils/LanguageContext";
import {textFormatAmountFn} from "@/app/utils/Common";
import TableRow from '@mui/material/TableRow';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { textSize, text_size } from "@/app/utils/MixinSize";
import styled from "styled-components";

const BettingPoolTableCell = styled(TableCell)(() => ({
    [`&`]:{
        verticalAlign: "middle",
    },
    [`&.${tableCellClasses.head}`]: {
      color: "#333333",
      backgroundColor: "#E1E1E1",
      fontWeight: 400,
      padding: "8px",
      ...textSize(11),
      textAlign: "left",
      height: "16px",
      lineHeight: "14px",
    },
    [`&.${tableCellClasses.body}`]: {
        color: "#333333",
        fontWeight: 500,
        padding: "8px",
        ...textSize(13),
        textAlign: "left",
        height: "40px",
        lineHeight: "18px",
      }
  }));

export default function Jackpotremarks(props:any){

    type remarksDataType={
        [key:string]:number
    }

    const {bettingPool,type}=props
    const { state: lang } = useLanguage();
    const { t } = lang;
    const remarksFormat:string=t("QuartetandFirst4Jackpot")   
    
    
    console.log(remarksFormat)

    const GetRemarksData=(data:any):remarksDataType=>{
        const remarksData ={} as remarksDataType
        if(data){
            for(const item of data){
                const races=item?.leg?.races
                const jackpot=Number(item.jackpot)
                if(races&&jackpot>0){
                    for(const race of races){
                        if(!remarksData[race]){
                            remarksData[race]=jackpot
                        }
                    }
                }
            }
        }
        return remarksData
    }

    const MergeRemarksData=(data1:remarksDataType,data2:remarksDataType):remarksDataType=>{
        for(const race in data2){
            if(data1.hasOwnProperty(race)){
                continue
            }
            else{
                data1[race]=data2[race]
            }
        }
        return data1
    }

    const Genremarks=()=>{
        const FF=bettingPool?.FF
        const QTT=bettingPool?.QTT

        const FFRemarksData = GetRemarksData(FF)
        const QTTRemarksData = GetRemarksData(QTT)

        const remarksData=MergeRemarksData(FFRemarksData,QTTRemarksData)

        const remarksDataArry = Object.keys(remarksData).map((race)=>{
            const jackpot=`$${textFormatAmountFn(remarksData[race],0)}`
            return `${remarksFormat.replace("{X}",race).replace("${XX}",jackpot)}`
        })

        const remarksDataStr=remarksDataArry.join("/ ")

        return(<>
            {remarksDataStr?.length>0&&<TableRow sx={{background:"#ffffff"}}>
                    <BettingPoolTableCell colSpan={2}>
                        {remarksDataStr}
                    </BettingPoolTableCell>                
                </TableRow>}
        </>
        )
    }
    return(
        <>
            <Genremarks></Genremarks>
        </>
    )
}
